module.exports = __webpack_public_path__ + "static/media/icon-medium-email.31b5d624.svg";